import { render, staticRenderFns } from "./PriceSelection.vue?vue&type=template&id=445d382e&scoped=true&"
import script from "./PriceSelection.vue?vue&type=script&lang=js&"
export * from "./PriceSelection.vue?vue&type=script&lang=js&"
import style0 from "./PriceSelection.vue?vue&type=style&index=0&id=445d382e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445d382e",
  null
  
)

export default component.exports